export const routes = [
  {
    path: '/test/**',
    name: 'Test',
    component: () => import('../views/test/TestProxy')
  },
  {
    path: '/sysadmin/main',
    name: 'SystemAdmin',
    component: () => import('../views/sysadmin/SysAdminMain')
  },
  {
    path: '/:roomUrlId',
    name: 'RoomUrlId',
    component: () => import('../views/RoomProxy')
  },
  {
    path: '/room/:roomId',
    name: 'Room',
    component: () => import('../views/RoomProxy')
  },
  {
    path: '/r-v3/room/:roomId',
    name: 'Room',
    component: () => import('../views/RoomProxy')
  },
  {
    path: '/room/mobile/token/:token',
    name: 'MobileRoom',
    component: () => import('../views/MobileProxy')
  },
  {
    path: '/room/common/popup',
    alias: ['/room/common/popup', '/r-v3/room/common/popup'],
    name: 'RoomPopup',
    component: () => import('../views/EmptyPage')
  },
  {
    path: '/auth/login',
    name: 'login',
    component: () => import('../views/Login')
  },
  {
    path: '/service/room',
    name: 'Service',
    component: () => import('../views/Service')
  },
  {
    path: '/room/enter/error',
    name: 'roomEnterError',
    component: () => import('../views/RoomEnterError')
  },
  {
    path: '*',
    name: 'notFound',
    component: () => import('../views/NotFound')
  }
]
